<template>
  <div class="u-margin-bottom-xsmall">
    <h4>
      {{ title }}
    </h4>
    <p class="u-color-muted">
      <small> {{ description }}</small>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: "",
      type: String,
    },
    description: {
      default: "",
      type: String,
    },
  },
};
</script>

<style></style>
